export const filterQuizzes = (quizzes, { search = '', sort = 'none' } = {}) => {
    const searchText = search.trim().toLowerCase();
    return (quizzes || [])
        .filter(({ title }) => (title || '').toLowerCase().includes(searchText))
        .sort((a, b) => {
            if (sort === 'none') return 0;
            const aTitle = (a.title || '').toLowerCase();
            const bTitle = (b.title || '').toLowerCase();
            const comparison = aTitle < bTitle ? -1 : aTitle > bTitle ? 1 : 0;
            return sort === 'title-desc' ? -comparison : comparison;
        });
};
